var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('p',{staticClass:"text-center card-text"},[_vm._v(_vm._s(_vm.dev.devcName))]),_c('canvas',{attrs:{"id":_vm.canId}}),_c('p',{staticClass:"text-right card-text"},[_vm._v(_vm._s(_vm.device.recentSeries ? _vm.recentSeries.datetime : ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }